import { render, staticRenderFns } from "./select-extras-info.vue?vue&type=template&id=07631de8&scoped=true"
import script from "./select-extras-info.vue?vue&type=script&lang=ts"
export * from "./select-extras-info.vue?vue&type=script&lang=ts"
import style0 from "./select-extras-info.vue?vue&type=style&index=0&id=07631de8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07631de8",
  null
  
)

export default component.exports